import {TextTKey} from '../../../common/type';

export interface ContentHomeTabItem extends TextTKey {
  id: ContentHomeTabType;
  isPreview?: boolean; // 첫 화 보기. 동적으로 보여줘야하는 탭이라 필드 추가
}

export enum ContentHomeTabType {
  overview = 'overview',
  preview = 'preview',
  product = 'product',
  about = 'about',
  notice = 'notice',
  comment = 'comment',
}

export enum PcContentHomeTabType {
  overview = 'overview',
  about = 'about',
  notice = 'notice',
}

export enum MobileContentHomeTabType {
  preview = 'preview',
  product = 'product',
  about = 'about',
  notice = 'notice',
  comment = 'comment',
}
